import { userRequest } from "../requestMethods";
import {
  getCityStart,
  getCitySuccess,
  getCityFailure,
} from "../redux/cityRedux";

export const getCities = async (dispatch) => {
  dispatch(getCityStart());
  try {
    const res = await userRequest.get("comboApi/combosCity/getActiveCity");

    if (res.status === 200) {
      console.log(res, "res.data for categories");
      dispatch(getCitySuccess(res.data.data));
    }
  } catch (err) {
    dispatch(getCityFailure());
  }
};
